import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "line-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "item-symbol" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: "line-item"
      }, [
        _createElementVNode("div", {
          class: "item-tag",
          onClick: ($event: any) => (_ctx.handleClick(item))
        }, [
          _renderSlot(_ctx.$slots, "tag", {}, () => [
            _createTextVNode(_toDisplayString(item.tag), 1)
          ])
        ], 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "symbol", {}, () => [
            (!item.type || item.type === 'circle')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["item-circle", _ctx.getColorClass(item.color)]),
                  style: _normalizeStyle(_ctx.getStyle(item))
                }, null, 6))
              : _createCommentVNode("", true)
          ])
        ]),
        _renderSlot(_ctx.$slots, "title", {}, () => [
          (_ctx.hasTitle)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "item-title",
                onClick: ($event: any) => (_ctx.handleClick(item))
              }, _toDisplayString(item.title), 9, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "brief", { item: item }, () => [
          (!item.htmlMode)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["item-brief", item.type]),
                onClick: ($event: any) => (_ctx.handleClick(item))
              }, _toDisplayString(item.brief), 11, _hoisted_5))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["item-brief", item.type]),
                onClick: ($event: any) => (_ctx.handleClick(item)),
                innerHTML: item.brief
              }, null, 10, _hoisted_6)),
          _createTextVNode(" + ")
        ])
      ]))
    }), 128))
  ]))
}